import Vue from 'vue'
import Vuex from 'vuex'
import settings from '../settings'
import Axios from 'axios'
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    status: '',
    user: {
      userName: '',
      userLastName: '',
      userAvatar: '',
      userPhone: '',
      userEmail: '',
      city: '',
      userID: ''
    },
    localCart: []
  },
  mutations: {
    SET_CART(state, data) {
      state.localCart = data;
    },
    SET_USER_INFO(state, userInfo) {
      state.status = 'autorized';
      state.user.userName = userInfo.userName;
      state.user.userLastName = userInfo.userLastName;
      state.user.userPhone = userInfo.userPhone;
      state.user.userEmail = userInfo.userEmail;
      state.user.userAvatar = userInfo.userAvatar;
      state.user.city = userInfo.city;
      state.user.userID = userInfo.userID;
    },
    AUTH_SUCCESS(state, userInfo) {
      state.status = 'autorized';
      state.user.userName = userInfo.userName;
      state.user.userLastName = userInfo.userLastName;
      state.user.userPhone = userInfo.userPhone;
      state.user.userEmail = userInfo.userEmail;
      state.user.userAvatar = userInfo.userAvatar;
      state.user.city = userInfo.city;
      state.user.userID = userInfo.userID;
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
      localStorage.setItem('userID', JSON.stringify(userInfo.userID));
    },
    AUTH_ERROR(state) {
      state.status = '';
      state.user.userName = '';
      state.user.userLastName = '';
      state.user.userPhone = '';
      state.user.userEmail = '';
      state.user.userAvatar = '';
      state.user.city = '';
      state.user.userID = '';
      localStorage.removeItem('userInfo');
      localStorage.removeItem('userID');
    },
    SET_NEW_PRODUCT_IN_CART(state, data) {
      state.localCart[data.productId] = data;
    }
  },
  actions: {
    LOGIN({ commit }, user) {
      return new Promise((resolve, reject) => {
        Axios({
          method: 'post',
          url: settings.apiUrl + '/auth/',
          data: JSON.stringify(user)
        }).then(resp => {
          let userInfo = {
            userEmail: resp.data.data.email,
            userPhone: resp.data.data.phone,
            userName: resp.data.data.name,
            userLastName: resp.data.data.lastName,
            userAvatar: resp.data.data.avatar,
            city: resp.data.data.city,
            userID: resp.data.data.id
          }
          commit('AUTH_SUCCESS', userInfo)
          resolve(resp)
        }).catch(err => {
          commit('AUTH_ERROR')
          reject(err)
        })
      })
    },
    LOGOUT({ commit }) {
      commit('AUTH_ERROR');
    },
    UPLOAD_AVATAR({ commit }, data) {
      return new Promise((resolve, reject) => {
        Axios({
          method: 'post',
          url: settings.apiUrl + '/avatar/',
          data: JSON.stringify(data)
        }).then(resp => {
          resolve(resp)
        })
          .catch(err => {
            reject(err)
          })
      })
    },
    // Получить информацию о пользователе по его ID и закинуть в state
    UPDATE_USER_INFO({ commit }) {
      let userID = JSON.parse(localStorage.getItem('userInfo')).userID;
      return new Promise((resolve, reject) => {
        Axios({
          method: 'get',
          url: settings.apiUrl + '/user/',
          headers: {
            'X-BitrixUserId': userID
          }
        }).then(resp => {
          let userInfo = {
            userName: resp.data.data.name,
            userLastName: resp.data.data.lastName,
            userPhone: resp.data.data.phone,
            userEmail: resp.data.data.email,
            userAvatar: resp.data.data.avatar,
            city: resp.data.data.city,
            userID: resp.data.data.id
          }
          commit('AUTH_SUCCESS', userInfo)
          resolve(resp)
        })
          .catch(err => {
            commit('AUTH_ERROR')
            reject(err)
          })
      });
    },
    // Заполнить state информацией с localStorage
    SET_USERINFO_FROM_LOCAL_STORAGE({ commit }, data) {
      commit('SET_USER_INFO', data)
    },
    // Список коллекций
    GET_COLLECTION_LIST({ commit }) {
      let self = this;
      return new Promise((resolve, reject) => {
        Axios({
          method: 'get',
          url: settings.apiUrl + '/collections/'
        }).then(response => {
          let items = response.data.data;
          resolve(items);
        })
          .catch(err => {
            reject(err)
          })
      })
    },

    // Контроль отстройки: получить список коллекций последних двух сезонов
    GET_CONTROL_COLLECTION_LIST({ commit }) {

      return new Promise((resolve, reject) => {
        Axios({
          method: 'get',
          url: settings.apiUrl + '/collections_period/'
        }).then(response => {
          resolve(response);
        })
          .catch(err => {
            reject(err)
          })
      })
    },

    // Регистрация презентации - поиск клиента по словам
    COMPANY_SEARCH({ commit }, searchWord) {
      return new Promise((resolve, reject) => {
        Axios({
          method: 'POST',
          url: settings.apiUrl + '/search_company/',
          data: {
            "q": searchWord
          }
        }).then(resp => {
          resolve(resp)
        })
          .catch(err => {
            reject(err)
          })
      });
    },
    // Cохранить компанию
    SAVE_NEW_COMPANY({ commit }, company) {


      let companyInfo = {
        title: company.title,
        region: company.region,
        phone: company.phone,
        email: company.email,
        description: "Произвольный комментарий"
      }


      return new Promise((resolve, reject) => {
        Axios({
          method: 'post',
          url: settings.apiUrl + '/company/0/',
          data: companyInfo
        }).then(response => {
          company.id = response.data.data.id;
          resolve(response)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // Зарегистрировать презентацию
    PRESENTATION_REGISTER({ commit }, info) {

      let presentationData = {
        companyId: info.id,
        collectionId: JSON.parse(localStorage.getItem('RegistrationCollectionInfo')).collectionID,
        companyName: info.title,
        email: info.email,
        phone: info.phone,
        region: info.region,
        datePresentation: info.presentationDate,
        goal: []
      }

      return new Promise((resolve, reject) => {
        Axios({
          method: 'post',
          url: settings.apiUrl + '/schedule/0/add/',
          data: presentationData
        }).then((response) => {
          resolve(response);
        }).catch(err => {
          reject(err)
        })
      });

    },
    // Добавляем цели/планы презентации
    UPDATE_PRESENTATION({ commit }, info) {
      let id;
      if (info.presentationID) {
        id = info.presentationID;
      } else {
        id = info.id
      }

      return new Promise((resolve, reject) => {
          if(parseInt(id) > 0){
                Axios({
                method: 'post',
                url: settings.apiUrl + '/schedule/' + id + '/update/',
                data: JSON.parse(JSON.stringify(info))
                }).then(resp => {
                resolve(resp)
                }).catch(err => {
                reject(err)
                })
            }
            else{
                reject({response: {status:503}})
            }
      })
    },
    // Получить список презентаций у текущего пользователя
    GET_PRESENTATION_LIST({ commit, state }) {
      return new Promise((resolve, reject) => {
        Axios({
          method: 'get',
          url: settings.apiUrl + '/presentations/',
        }).then(resp => {
          resolve(resp)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // Получить список проведенных замен
    GET_REPLACEMENT_LIST({ commit }) {
      let userID = JSON.parse(localStorage.getItem('userID'));
      return new Promise((resolve, reject) => {
        Axios({
          method: 'get',
          url: settings.apiUrl + '/replacements/' + userID + '/manager/',
        }).then(resp => {
          resolve(resp)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // Получить список проведенных отстроек
    GET_MANUFACTURES_LIST({ commit }) {
      return new Promise((resolve, reject) => {
        Axios({
          method: 'get',
          url: settings.apiUrl + '/manufactures/',
        }).then(resp => {
          resolve(resp)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // Получить список элементов в каталоге
    GET_CATALOG_LIST({ commit }, collectionId) {

      return new Promise((resolve, reject) => {
        Axios({
          method: 'get',
          url: settings.apiUrl + '/collection/' + collectionId + '/'
        }).then(response => {
          // let info = response.data.data;
          // commit('PRODUCT_LIST', info.products);
          resolve(response);
        })
          .catch(err => {
            reject(err)
          })
      })
    },
    // Получить продукт из текущей коллекции в localStorage по id
    GET_CURRENT_PRODUCT({ commit }, data) {
      return new Promise((resolve, reject) => {
        let currentCollection = JSON.parse(localStorage.getItem('currentCollection'));
        let collectionID = currentCollection.info.id;
        // Если коллекция в localStorage актуальная - вернуть товар
        if (collectionID == data.collectionID) {
          let currentProduct = currentCollection.products.find(x => x.id === data.productID)
          resolve(currentProduct)
        } else {
          console.error("В localStorage не та коллекция")
        }
      })
    },
    // Добавляем элементы в локальную корзину
    SET_INFO_TO_LOCAL_CART({ commit }, data) {
      let cart = this.getters.GET_LOCAL_CART;  //Вытянуть текущую корзину из state

      if (cart.length == 0) { //Если корзина пустая, добавляем текущий элемент
        cart.push(data);
        commit('SET_CART', cart)
      } else {
        cart.forEach((el, i) => {
          if (el.optionID === data.optionID && el.currentSize == data.currentSize && el.productID == data.productID) {
            // Если в корзине уже есть такой товар - удаляем и добавляем такой же, но с измененной информацией
            cart.splice(i, 1);
          }
        });
        cart.push(data);
        commit('SET_CART', cart)
      }
    },
    //Отправить заказ
    CREATE_ORDER({ commit }) {
      let localCart = JSON.parse(localStorage.getItem('miniCart'));
      let currentClientInfo = JSON.parse(localStorage.getItem('currentClientInfo'));

      function dateFormat(str) {
        let arr = str.split('-');
        [arr[0], arr[2]] = [arr[2], arr[0]];
        return arr.join('.')
      }

      let cart = {}

      cart.companyId = currentClientInfo.clientId;
      cart.collectionId = currentClientInfo.collectionId;
      cart.presentationId = currentClientInfo.id;
      // cart.datePresentation = dateFormat(currentClientInfo.datePresent)
      cart.datePresentation = currentClientInfo.datePresent;
      cart.rating = [];
      cart.baskets = []

      for (var key in localCart) {
        localCart[key].forEach((el) => {
          let obj = {}
          if (el.rating || el.comment) {
            cart.rating.push(el)
          }
          if (el.typeProduct) {
            obj.typeProduct = el.typeProduct;
            obj.collectionId = el.collectionID;
            obj.productId = el.productID;
            obj.productName = el.productName;
            obj.offerId = el.offerID;
            obj.offerName = el.offerName;
            obj.colorTitle = el.colorName;
            obj.quantity = el.quantity;
          }
          cart.baskets.push(obj)
        })
      }

      return new Promise((resolve, reject) => {
        Axios({
          method: 'post',
          url: settings.apiUrl + '/order/',
          data: cart
        }).then(response => {
          resolve(response);
        }).catch(err => { reject(err) })
      })
    },
    //Если в корзине ничего нет, отправить пустой заказ
    CREATE_ORDER_EMPTY({ commit }) {
      let currentClientInfo = JSON.parse(localStorage.getItem('currentClientInfo'));

      function dateFormat(str) {
        let arr = str.split('-');
        [arr[0], arr[2]] = [arr[2], arr[0]];
        return arr.join('.')
      }

      let cart = {}

      cart.companyId = currentClientInfo.clientId;
      cart.collectionId = currentClientInfo.collectionId;
      cart.presentationId = currentClientInfo.id;
      // cart.datePresentation = dateFormat(currentClientInfo.datePresent)
      cart.datePresentation = currentClientInfo.datePresent;

      return new Promise((resolve, reject) => {
        Axios({
          method: 'post',
          url: settings.apiUrl + '/order/',
          data: cart
        }).then(response => {
          resolve(response);
        }).catch(err => { reject(err) })
      })


    },
    // Очистить localStorage
    CLEAR_LOCAL_STORAGE({ commit }) {

      if (JSON.parse(localStorage.getItem('orderID'))) {
        localStorage.removeItem('orderID');  //Удалить ID заказа
      }

      if (JSON.parse(localStorage.getItem('currentCollection'))) {
        localStorage.removeItem('currentCollection');  //Удалить информацию о текущей коллекции
      }

      if (JSON.parse(localStorage.getItem('currentClientInfo'))) {
        localStorage.removeItem('currentClientInfo'); //Удалить информацию о текущем клиенте и компании
      }

      if (JSON.parse(localStorage.getItem('RegistrationCollectionInfo'))) {
        localStorage.removeItem('RegistrationCollectionInfo'); //Удалить информацию о зарегистрированный коллекции
      }

      localStorage.setItem('miniCart', JSON.stringify({}));  //Очистить корзину

    },

    //Работа по замене - отправить отчет
    MANUFACTURE_SEND_REPORT({ commit }, reportID) {
      return new Promise((resolve, reject) => {
        Axios({
          method: 'post',
          url: settings.apiUrl + '/manufacture_report/',
          data: {
            "id": reportID
          }
        }).then(response => {
          resolve(response);
        }).catch(err => { reject(err) })
      })
    },
    //Удалить запланированную презентацию
    DELETE_PRESENTATION({ commit }, data) {
      return new Promise((resolve, reject) => {
        Axios({
          method: 'post',
          url: settings.apiUrl + '/schedule/' + data.presentationID + '/delete/',
          data: data
        }).then(response => {
          resolve(response);
        }).catch(err => { reject(err) })
      })
    },
    //Отправить повторно отчет о презентации
    RE_SEND_REPORT({ commit }, data) {
      return new Promise((resolve, reject) => {
        Axios({
          method: 'post',
          url: settings.apiUrl + '/report/',
          data: data
        }).then(resp => {
          resolve(resp)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // Список клиентов текущего пользователя
    GET_CLIENTS_LIST({ commit }) {
      return new Promise((resolve, reject) => {
        Axios({
          method: 'get',
          url: settings.apiUrl + '/companies/',
          headers: {
            'X-BitrixUserId': JSON.parse(localStorage.getItem('userID'))
          }
        }).then(resp => {
          resolve(resp)
        }).catch(err => {
          reject(err)
        })
      })
    },
    //Отредактировать клиента
    EDIT_CLIENT_INFO({ commit }, data) {
      return new Promise((resolve, reject) => {
        Axios({
          method: 'POST',
          url: settings.apiUrl + '/company/' + data.clientId + '/',
          data: data
        }).then(response => {
          resolve(response)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // Получить список презентаций одного клиента
    GET_CLIENT_PRESENTATIONS({ commit }, id) {
      return new Promise((resolve, reject) => {
        Axios({
          method: 'GET',
          url: settings.apiUrl + '/presentation/' + id + '/company/',
        }).then(resp => {
          resolve(resp)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // Информация о запланированной презентации(для страницы редактирования)
    GET_PRESENTATION_INFO({ commit }, id) {
      return new Promise((resolve, reject) => {
        Axios({
          method: 'GET',
          url: settings.apiUrl + '/presentations/' + id + '/detail/',
        }).then(resp => {
          resolve(resp)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // Получить список разделов каталога товара
    GET_SHOP_CATALOG_LIST({ commit }, data) {
      return new Promise((resolve, reject) => {
        Axios({
          method: 'post',
          url: settings.apiUrlShop[data.shopName] + '/store/sections/',
          headers: {
            'X-BitrixUserId': JSON.parse(localStorage.getItem('userID'))
          },
          data: {
            "parentId": data.parentID
          }
        }).then(resp => {
          resolve(resp)
        }).catch(err => {
          reject(err)
        })
      })
    },

    // Получить список товаров в магазине
    GET_CATALOG_LIST_SHOP({ commit }, data) {

      return new Promise((resolve, reject) => {
        Axios({
          method: 'get',
          url: settings.apiUrlShop[data.shopName] + '/store/section/' + data.collectionID + '/'
        }).then(response => {
          resolve(response);
        })
          .catch(err => {
            reject(err)
          })
      })
    },

    // Корзина магазина
    CREATE_ORDER_SHOP({ commit }, shopName) {
      let localCart = JSON.parse(localStorage.getItem('miniCart'));
      let currentClientInfo = JSON.parse(localStorage.getItem('currentClientInfo'));

      let cart = {}

      cart.companyId = currentClientInfo.companyId;
      cart.datePresentation = currentClientInfo.datePresentation;
      cart.baskets = []

      for (var key in localCart) {
        localCart[key].forEach((el) => {
          let obj = {}

          if (el.typeProduct) {
            obj.typeProduct = el.typeProduct;
            obj.collectionId = el.collectionID;
            obj.productId = el.productID;
            obj.productName = el.productName;
            obj.offerId = el.offerID;
            obj.offerName = el.offerName;
            obj.colorTitle = el.colorName;
            obj.quantity = el.quantity;
          }

          cart.baskets.push(obj)
        })
      }

      return new Promise((resolve, reject) => {
        Axios({
          method: 'post',
          url: settings.apiUrlShop[shopName] + '/store/order/',
          data: cart
        }).then(response => {
          resolve(response);
        }).catch(err => { reject(err) })
      })
    },

    // Поиск в магазине
    SHOP_SEARCH({ commit }, data) {

      return new Promise((resolve, reject) => {
        Axios({
          method: 'post',
          url: settings.apiUrlShop[data.shopName] + '/store/search/',
          data: data
        }).then(response => {
          resolve(response);
        }).catch(err => { reject(err) })
      })
    },
    // Контроль отстройки: создание
    CREATE_CONTROL({ commit }, data) {

      return new Promise((resolve, reject) => {
        Axios({
          method: 'post',
          url: settings.apiUrl + '/manufacture/0/add/',
          data: data
        }).then(response => {
          resolve(response);
        }).catch(err => { reject(err) })
      })
    },

    // Контроль отстройки: каталог, получить список товаров
    GET_CONTROL_CATALOG_LIST({ commit }, reportId) {
      return new Promise((resolve, reject) => {
        Axios({
          method: 'get',
          url: settings.apiUrl + '/manufacture/' + reportId + '/show/',
        }).then(response => {
          resolve(response);
        }).catch(err => { reject(err) })
      })
    },

    // Контроль отстройки: Получить продукт из текущей коллекции в localStorage по id
    CONTROL_GET_CURRENT_PRODUCT({ commit }, data) {
      return new Promise((resolve, reject) => {
        let collections = JSON.parse(localStorage.getItem('currentCollection'));
        let currentCollection = collections.find(x => x.id == data.collectionID)

        if (currentCollection) {
          let currentProduct = currentCollection.products.find(x => x.id === data.productID);
          resolve(currentProduct)
        } else {
          console.error('В localStorage какие-то проблемы с коллекцией')
        }
      })
    },
    // Контроль отстройки: завершить отстройку и отправить данные
    CONTROL_CREATE_ORDER({ commit }, data) {
      let reportId = JSON.parse(localStorage.getItem('currentControlID'));
      return new Promise((resolve, reject) => {
        Axios({
          method: 'post',
          url: settings.apiUrl + '/manufacture_order/' + reportId + '/',
          data: data
        }).then(response => {
          resolve(response);
        }).catch(err => { reject(err) })
      })
    },
    // Контроль отстройки: Оставить отзыв
    CONTROL_ADD_COMMENT({ commit }, data) {

      return new Promise((resolve, reject) => {
        Axios({ //Сохранить комментарий
          method: 'post',
          url: settings.apiUrl + '/manufacture/' + data.reportId + '/update/',
          data: data
        })
          .then(response => {
            Axios({ //Отправить отчет на почту
              method: 'post',
              url: settings.apiUrl + '/manufacture_report/',
              data: {
                "id": data.reportId
              }
            }).then(resp => {
              resolve(resp);
            })

          })
          .catch(err => { reject(err) })
      })
    },


    //Работа по замене - сохранить отчет
    REPLACEMENT_SAVE_REPORT({ commit }, data) {
      return new Promise((resolve, reject) => {
        Axios({
          method: 'post',
          url: settings.apiUrl + '/replacement/',
          data: data
        }).then(response => {
          resolve(response);
        }).catch(err => { reject(err) })
      })
    },


    // Работа по замене. Отправить отчет
    REPLACEMENT_SEND_REPORT({ commit }, reportID) {

      return new Promise((resolve, reject) => {
        Axios({
          method: 'post',
          url: settings.apiUrl + '/replacement_report/',
          data: {
            "hash": reportID
          }
        }).then(response => {
          resolve(response);
        }).catch(err => { reject(err) })
      })
    }
  },
  getters: {
    GET_USER_INFO(state) {
      return state.user;
    },
    GET_LOCAL_CART(state) {
      return state.localCart
    }
  }
})
